/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_7Inputs */

const en_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video export with burnt-in subtitles`)
};

const fr_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation vidéo avec sous-titres incrustés`)
};

const de_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport mit eingebetteten Untertiteln`)
};

const it_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione video con sottotitoli incorporati`)
};

const ru_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео с встроенными субтитрами`)
};

const es_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de vídeo con subtítulos incorporados`)
};

const zh_cn2_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带内嵌字幕的视频`)
};

const ja_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕を焼き込んだビデオのエクスポート`)
};

const hi_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो को सबटाइटल के साथ एक्सपोर्ट करें`)
};

const pt_pt2_signup_feature_starter_7 = /** @type {(inputs: Signup_Feature_Starter_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de vídeo com legendas incorporadas`)
};

/**
* | output |
* | --- |
* | "Video export with burnt-in subtitles" |
*
* @param {Signup_Feature_Starter_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_7 = /** @type {((inputs?: Signup_Feature_Starter_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_7(inputs)
	if (locale === "de") return de_signup_feature_starter_7(inputs)
	if (locale === "it") return it_signup_feature_starter_7(inputs)
	if (locale === "ru") return ru_signup_feature_starter_7(inputs)
	if (locale === "es") return es_signup_feature_starter_7(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_7(inputs)
	if (locale === "ja") return ja_signup_feature_starter_7(inputs)
	if (locale === "hi") return hi_signup_feature_starter_7(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_7(inputs)
	return en_signup_feature_starter_7(inputs)
});